import { Injectable } from '@angular/core';
import { ContentEditorSection } from 'app/modules/main/components/content-editor/content-editor-section';
import { UuidGenerator } from 'app/modules/main/services/uuid-generator.service';

@Injectable({ providedIn: 'root' })
export class ContentEditorSectionFactory {

  constructor(
    readonly uuidGenerator: UuidGenerator,
  ) {
  }

  create(
    initialContent: string = ''
  ): ContentEditorSection {
    return new ContentEditorSection(this.uuidGenerator, initialContent);
  }

}
